// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Ukraine */
const UA = /^(?:790\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\d{7})$/;

export default UA;
